import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()

const myPOList = payload => AxiosClient.get('/system-po-list', payload);
const pOPaymentList = payload => AxiosClient.get('/search-payment', payload);
const genertePaymentList = payload => AxiosClient.post('/generate-payment', payload);
const getPendingPaymentsPoList = payload => AxiosClient.get('/pending-payment-po', payload);
const fetchInvoiceData = () => AxiosClient.get('/fetch-invoice-data');
const fetchPorts = () => AxiosClient.get('/port-list');
const fetchWorkflow = () => AxiosClient.get('/fetch-workflow-costcentre');
const fetchLocation = () => AxiosClient.get('/fetch-loaction');



const createInvoice = payload => AxiosClient.post('/create-invoice', payload);

const fetchInvoiceForIgm = () => AxiosClient.get('/fetch-invoice-igm');
const createIgm = payload => AxiosClient.post('/create-igm', payload);

const fetchInvoiceForCustomsList = () => AxiosClient.get('/fetch-customs-records');
const addCustomsHistory = payload => AxiosClient.post('/create-customs', payload);


const fetchInvoiceForLogisticsList = (payload) => AxiosClient.get(`/fetch-logistics-records?v_type=${payload}`);
const fetchInvoiceForLogisticsListByCustomId = (customs_id) => AxiosClient.get(`/fetch-logistics-records?customs_id=${customs_id}`);

const addLogisticsHistory = payload => AxiosClient.post('/create-logistics', payload);

const fetchInvoiceListForTelx = () => AxiosClient.get('/fetch-telx-invoice');
const getSASToBlob = payload => AxiosClient.post('/file-upload-blob', payload)
const addTelxHistory = payload => AxiosClient.post('/create-telx', payload);
const fetchTelxList = () => AxiosClient.get('/fetch-telx-history');

const addInsuranceCharge = payload => AxiosClient.post('/insurance-charge', payload);
const searchInsuranceCharge = payload => AxiosClient.get(`/insurance-list?invoice_id=${payload}`)

const pendingInsurancePayment = () => AxiosClient.get('/pending-insurance-payment-po');
const addInsurancePaymentHistory = payload => AxiosClient.post('/generate-insurance-payment', payload);

const pendingFreightPayment = () => AxiosClient.get('/pending-freight-payment-po');
const addFreightPaymentHistory = payload => AxiosClient.post('/generate-freight-payment', payload);

const pendingDutyFeesPayment = () => AxiosClient.get('/pending-duty-fees-payment-invoice');
const addDutyFeesPaymentHistory = payload => AxiosClient.post('/generate-duty-fees-payment', payload);


export {
  myPOList,
  pOPaymentList,
  genertePaymentList,
  getPendingPaymentsPoList,
  fetchWorkflow,
  fetchLocation,
  fetchInvoiceData,
  createInvoice,
  fetchInvoiceForIgm,
  createIgm,
  fetchInvoiceForCustomsList,
  addCustomsHistory,
  fetchInvoiceForLogisticsList,
  addLogisticsHistory,
  fetchInvoiceForLogisticsListByCustomId,
  fetchInvoiceListForTelx,
  getSASToBlob,
  addTelxHistory,
  fetchTelxList,
  addInsuranceCharge,
  searchInsuranceCharge,
  pendingInsurancePayment,
  addInsurancePaymentHistory,
  pendingFreightPayment,
  addFreightPaymentHistory,
  pendingDutyFeesPayment,
  addDutyFeesPaymentHistory,
  fetchPorts

}